export const checkIfWorkingDay = (date, workingDays) => {
    switch (date.getDay()) {
        case 0:
            return workingDays.sunday;
        case 1:
            return workingDays.monday;
        case 2:
            return workingDays.tuesday;
        case 3:
            return workingDays.wednesday;
        case 4:
            return workingDays.thursday;
        case 5:
            return workingDays.friday;
        case 6:
            return workingDays.saturday;
        default:
            return false;
    }
};
